/** Per-device rail pin preference, keyed per host surface. localStorage throws in private mode / on quota, so both sides swallow. */
export function railPinPreference(key: string): { read(): boolean; write(pinned: boolean): void } {

  return {
    read(): boolean {

      try {
        return localStorage.getItem(key) === '1';
      } catch {
        return false;
      }
    },
    write(pinned: boolean): void {

      try {
        localStorage.setItem(key, pinned ? '1' : '0');
      } catch {
        /* private mode / quota */
      }
    },
  };
}
